<script>
  import shipmentComponent from '@/components/fba_shipment/shipment.vue';
  import Pagination from '@/components/pagination/pagination.vue';
  import {
    STATUS_FAIL,
    STATUS_INIT,
    STATUS_LOADING,
    STATUS_OK,
    STATUS_SHIPPED,
    TYPE_FBA
  } from '@/variables';

  export default {
    data() {
      return {
        status: STATUS_INIT,
        STATUS_INIT, STATUS_LOADING, STATUS_OK, STATUS_FAIL,
        search: '',
        shipments: null,
        page: 1,
        count: null,
        itemsPerPage: 10,
      };
    },
    components: { shipment_component: shipmentComponent, Pagination, },
    created() {
      this.load();
    },
    computed: {},
    watch: {
      page() {
        this.load();
      },
      search() {
        this.load();
      },
    },
    methods: {
      load() {
        this.status = STATUS_LOADING;

        const payload = {
          status: STATUS_SHIPPED,
          type: TYPE_FBA,
          page: this.page,
          search: this.search,
        };

        this.$store.dispatch('shipments/get_list', payload)
          .then((data) => {
            this.status = STATUS_OK;
            this.shipments = data.data;
            this.count = data.count;
          })
          .catch((err) => {
            console.log('catch', err);
            this.status = STATUS_FAIL;
          });
      },
      set_search(str) {
        this.search = str;
      },
    },
  };
</script>
<template src="./shipped-fba-shipment.pug" lang="pug"></template>
